export const GET_GROUP_LIST = 'GET_GROUP_LIST';
export const getGroupList = () => ({
  type: GET_GROUP_LIST,
});
